module.exports = __webpack_public_path__ + "static/partnership1-6fe00528bdfc5fe4b65c34b038d1e57f.png";